<script setup lang="ts">
import HeaderDesktopNavbar from './HeaderDesktopNavbar.vue';
import HeaderDesktopDropdown from './HeaderDesktopDropdown.vue';

const userStore = useUserStore();
const authStore = useAuthStore();
</script>

<template>
  <nav class="header__links">
    <HeaderDesktopNavbar />

    <template v-if="!userStore.user">
      <v-button
        small
        schema="outline"
        @click="authStore.handleIsOpened('login')"
      >
        Войти
      </v-button>
      <v-button
        schema="outline"
        small
        @click="authStore.handleIsOpened('register')"
      >
        Зарегистрироваться
      </v-button>
    </template>

    <HeaderDesktopDropdown />
  </nav>
</template>

<style lang="scss" scoped>
.header__links {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: end;

  @include media-breakpoint-down(md) {
    display: none;
  }
}
</style>
